import styles from "./FlexSpacer.module.css";

export function FlexSpacer() {
  return <div className={styles.root} />;
}
